import { render, staticRenderFns } from "./GRecaptcha.vue?vue&type=template&id=71a1dbb2"
import script from "./GRecaptcha.vue?vue&type=script&lang=js"
export * from "./GRecaptcha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports